const DISCORD_INVITE = 'https://discord.gg/YcEGRxaqcu';

export function openDiscord(): void {
  window.open(DISCORD_INVITE, '_blank', 'noopener');
}
